'use strict';
// Main
$(document).ready(() => {
	about();
	inizializza();
	menu();
	press();
	progetti();
	references();
	tornaSu();
	vetrina();
	gestisciCookies();
});

/**
 * Funzione ordinamento random elementi
 */
$.fn.shuffleChildren = function() {
    $.each(this.get(), function(index, el) {
        var $el = $(el);
        var $find = $el.children();

        $find.sort(function() {
            return 0.5 - Math.random();
        });

        $el.empty();
        $find.appendTo($el);
    });
};

/**
 * Funzione gestione about
 */
function about() {
	let primo = false;
	let precedente = null;
	let successivo = null;

	if ($('.about__container__bio').length > 0) {
		Pace.on('done', () => {
			$('.about__container article:first-child .about__container__bio__foto')
			.addClass('animated fadeInLeft');

			setTimeout(function() {
				$('.about__container article:first-child .about__container__bio__summary')
				.addClass('animated fadeInRight');
			}, 250);
		});

		$(window).on('scroll', function() {
			if ($(this).scrollTop() >=
			$('.about__container article:first-child .about__container__bio__foto')
			.offset().top +
			($('.about__container article:first-child .about__container__bio__foto')
			.outerHeight() / 2)) {
				precedente =
				$('.about__container article:first-child .about__container__bio__foto');
				successivo = $('.about__container article:first-child').next();

				successivo.find(' .about__container__bio__titoli__titolo')
				.addClass('animated fadeInLeft');

				setTimeout(function() {
					successivo.find(' .about__container__bio__titoli__sottotitolo')
					.addClass('animated fadeInLeft');
				}, 250);
				setTimeout(function() {
					successivo.find(' .about__container__bio__foto')
					.addClass('animated fadeInLeft');
				}, 500);
				setTimeout(function() {
					successivo.find(' .about__container__bio__summary')
					.addClass('animated fadeInRight');
				}, 750);

				primo = true;
			}
			if (primo && $(this).scrollTop() >=
			successivo.find('.about__container__bio__foto')
			.offset().top + (successivo.find('.about__container__bio__foto')
			.outerHeight() / 2)) {
				precedente = successivo;
				successivo = successivo.next();

				successivo.find('.about__container__bio__titoli__titolo')
				.addClass('animated fadeInLeft');

				setTimeout(function() {
					successivo.find('.about__container__bio__titoli__sottotitolo')
					.addClass('animated fadeInLeft');
				}, 250);
				setTimeout(function() {
					successivo.find('.about__container__bio__foto')
					.addClass('animated fadeInLeft');
				}, 500);
				setTimeout(function() {
					successivo.find('.about__container__bio__summary')
					.addClass('animated fadeInRight');
				}, 750);
			}
		});
	}
}

/**
 * Funzione gestione formattazione testi
 * @param {object} elemento Elemento DOM
 * @param {int} caratteri Caratteri da troncare
 */
function formattaTesto(elemento, caratteri) {
	let testo = elemento.text();

	if (testo.length > caratteri) {
		testo = testo.substring(0, caratteri - 3);
		testo = testo + '...';
	}

	elemento.html(testo);
}

/**
 * Funzione gestione inizializzazioni
 */
function inizializza() {
	// Preloader
	Pace.on('done', () => {
		$('.pace, #loading img, #loading').addClass('animated slideOutDown');
	});

	// Vetrina - Home
	if ($('.vetrina__container').length > 0) {
		$('.vetrina__container').shuffleChildren();
		$('.vetrina__container__margine').prependTo($('.vetrina__container'));
		$('.vetrina__container__spaziatore').prependTo($('.vetrina__container'));
		$('.vetrina__container').masonry({
			itemSelector: '.vetrina__container__progetto',
			columnWidth: '.vetrina__container__spaziatore',
			percentPosition: true,
			gutter: '.vetrina__container__margine',
		});
	}
	// Press
	if ($('.press__container__testata__container').length > 0) {
	$('.press__container__testata__container').masonry({
			itemSelector: '.press__container__testata__container__progetto',
			columnWidth: '.press__container__testata__container__spaziatore',
			percentPosition: true,
			gutter: '.press__container__testata__container__margine',
		});
	}
	// References
	if ($('.references__container__gallery__container').length > 0) {
		$('.references__container__gallery__container').masonry({
			itemSelector: '.references__container__gallery__container__referente',
			columnWidth: '.references__container__gallery__container__spaziatore',
			percentPosition: true,
		});
	}
	// Progetti - Slider
	if ($('.progetti__popup__container').length > 0) {
		$('.progetti__popup__container').superslides({
			pagination: false,
		});
	}
	// Press - Slider
	if ($('.press__popup__container').length > 0) {
		$('.press__popup__container').superslides({
			pagination: false,
		});
	}
	// Contacts
	if ($('.contact').length > 0) {
		$('<br /><span>info@rivasimone.it</span>')
		.appendTo('.contact__container__articolo__summary--contatti p');
	}
	// Privacy
	if ($('#privacy').length > 0) {
		$('.privacy__container__articolo__summary__corpo .email-utente')
		.html('<a class="' +
		'privacy__container__articolo__summary__link' +
		'" href="mailto:info@rivasimone.it?Subject=Informazioni" title="' +
		'Scrivici per richiedere informazioni al nostro studio'+
		'" tabindex="400">'+
		'info@rivasimone.it'+
		'</a>');
	}
	if ($('.footer').length > 0) {
		// Footer
		$('<a class="footer__container__info__corpo__link" '+
		'title="Contatta ora lo studio per richiedere informazioni" '+
		'href="mailto:info@rivasimone.it?subject=Informazioni" '+
		'tabindex="101">'+
		'info@rivasimone.it'+
		'</a>').appendTo('.footer__container__info__corpo .email-utente');
	}
}

/**
 * Funzione gestione menu
 */
function menu() {
	$('.menu-pulsante').on('click tap', () => {
		if (!$('.hamburger.hamburger--stand').hasClass('is-active')) {
			$('.hamburger.hamburger--stand').addClass('is-active');
			$('body').addClass('bloccato');
			$('.menu').addClass('aperto');

			setTimeout(() => {
				$('.menu').addClass('minimo');
			}, 500);

			$('.menu__container__link').each(function() {
				let elemento = this;

				setTimeout(() => {
					$(elemento).removeClass('animated fadeOutLeft');
					$(elemento).addClass('animated fadeInLeft');
				}, 500);
			});
		} else {
			$('.menu__container__link').each(function(i) {
				$(this).delay(250 * i)
				.removeClass('animated fadeInLeft')
				.addClass('animated fadeOutLeft');
			});

			setTimeout(() => {
				$('.menu').removeClass('minimo aperto');
			}, 250);

			$('body').removeClass('bloccato');
			$('.hamburger.hamburger--stand').removeClass('is-active');
		}
	});
	/* $(document).on('click tap', function(e) {
		// Se la propagazione è già stata bloccata allora rendi lo stato
		if (event.defaultPrevented) {
			return;
		}
		// Se il click non avviene sul selettore od un suo discendente
		if (!$(e.target).closest('.menu__container').length) {
			$('.menu__container__link').each(function(i) {
				$(this).delay(250 * i)
				.removeClass('animated fadeInLeft')
				.addClass('animated fadeOutLeft');
			});

			setTimeout(() => {
				$('.menu').removeClass('minimo aperto');
			}, 250);

			$('body').removeClass('bloccato');
			$('.hamburger.hamburger--stand').removeClass('is-active');
		}
	}); */

	// Voci attive
	if (window.location.pathname === '/' ||
	window.location.pathname === '/home' ||
	window.location.pathname === '/home/') {
	  $('.menu__container__link').removeClass('voce-attiva');
	  $('.menu__container__link[data-rel="home"]')
	  .addClass('voce-attiva');
	} else if (window.location.pathname === '/about' ||
	window.location.pathname === '/about/') {
	  $('.menu__container__link').removeClass('voce-attiva');
	  $('.menu__container__link[data-rel="about"]')
	  .addClass('voce-attiva');
	} else if (window.location.pathname === '/housing-leisure' ||
	window.location.pathname === '/housing-leisure/') {
	  $('.menu__container__link').removeClass('voce-attiva');
	  $('.menu__container__link[data-rel="housing & leisure"]')
	  .addClass('voce-attiva');
	} else if (window.location.pathname === '/horeca-retail' ||
	window.location.pathname === '/horeca-retail/') {
	  $('.menu__container__link').removeClass('voce-attiva');
	  $('.menu__container__link[data-rel="horeca & retail"]')
	  .addClass('voce-attiva');
	} else if (window.location.pathname === '/design-product' ||
	window.location.pathname === '/design-product/') {
	  $('.menu__container__link').removeClass('voce-attiva');
	  $('.menu__container__link[data-rel="design & product"]')
	  .addClass('voce-attiva');
	} else if (window.location.pathname === '/press-fairs' ||
	window.location.pathname === '/press-fairs/') {
	  $('.menu__container__link').removeClass('voce-attiva');
	  $('.menu__container__link[data-rel="press & fairs"]')
	  .addClass('voce-attiva');
	} else if (window.location.pathname === '/references' ||
	window.location.pathname === '/references/') {
	  $('.menu__container__link').removeClass('voce-attiva');
	  $('.menu__container__link[data-rel="references"]')
	  .addClass('voce-attiva');
	} else if (window.location.pathname === '/contact' ||
	window.location.pathname === '/contact/') {
	  $('.menu__container__link').removeClass('voce-attiva');
	  $('.menu__container__link[data-rel="contact"]')
	  .addClass('voce-attiva');
	}

	// Links - Animazione
	$('.menu__container__link').on('click tap', function(e) {
		e.preventDefault();

		$('.menu__container__link').each(function(i) {
			$(this).delay(250 * i)
			.removeClass('animated fadeInLeft')
			.addClass('animated fadeOutLeft');
		});

		setTimeout(() => {
			$('.menu').removeClass('minimo aperto');
		}, 250);

		$('body').removeClass('bloccato');
		$('.hamburger.hamburger--stand').removeClass('is-active');

		setTimeout(() => {
			window.location.href = $(this).attr('href');
		}, 750);
	});
}

/**
 * Funzione gestione press
 */
function press() {
	// Formattazione
	if ($('.press__container__testata__container__progetto__link__descrizione__titolo')
	.length > 0) {
		$('.press__container__testata__container__progetto__link__descrizione__titolo')
		.each(function() {
			formattaTesto($(this), 30);
		});
	}

	$(window).on('resize', function() {
		if ($('.press__container__testata__container__progetto__link__descrizione__corpo')
		.length > 0) {
			if ($(this).width() > 992) {
				$('.press__container__testata__container__progetto__link__descrizione__corpo')
				.each(function() {
					formattaTesto($(this), 100);
				});
			} else {
				$('.press__container__testata__container__progetto__link__descrizione__corpo')
				.each(function() {
					formattaTesto($(this), 60);
				});
			}
			if ($(this).height() < 640) {
				$('.press__popup__container__slider__elemento__didascalia')
				.each(function() {
					formattaTesto($(this), 60);
				});
			}
		}
	}).resize();

	// Effetti
	$('.press__container__testata__container__progetto__link')
	.on('click tap', (e) => {
		e.preventDefault();
		$('.press__popup').addClass('visibile');
	});

	Pace.on('done', () => {
		setTimeout(function() {
			$('.press__container__testata__container__progetto:not(:nth-child(2n)):not(:nth-child(3n))')
			.addClass('animated fadeInUp');
		}, 250);
		setTimeout(function() {
			$('.press__container__testata__container__progetto:nth-child(2n)')
			.addClass('animated fadeInUp');
		}, 500);
		setTimeout(function() {
			$('.press__container__testata__container__progetto:nth-child(3n)')
			.addClass('animated fadeInUp');
		}, 750);
		setTimeout(function() {
			$('.press__container__testata__container__progetto')
			.removeClass('animated fadeInUp').addClass('visibile');
		}, 1750);
	});
}

/**
 * Funzione gestione progetti
 */
function progetti() {
	let primo = false;
	let precedente = null;
	let successivo = null;

	// Formattazione
	if ($('.progetti__container__progetto__link__overlay__articolo__titolo')
	.length > 0) {
		$('.progetti__container__progetto__link__overlay__articolo__titolo')
		.each(function() {
			formattaTesto($(this), 40);
		});
	}

	$(window).on('resize', function() {
		if ($('.progetti__container__progetto__link__overlay__articolo__corpo')
		.length > 0) {
			if ($(this).width() < 480) {
				$('.progetti__container__progetto__link__overlay__articolo__corpo')
				.each(function() {
					formattaTesto($(this), 40);
				});
			} else if ($(this).width() < 992) {
				$('.progetti__container__progetto__link__overlay__articolo__corpo')
				.each(function() {
					formattaTesto($(this), 160);
				});
			} else {
				$('.progetti__container__progetto__link__overlay__articolo__corpo')
				.each(function() {
					formattaTesto($(this), 460);
				});
			}
			if ($(this).height() < 640) {
				$('.progetti__popup__container__slider__elemento__didascalia')
				.each(function() {
					formattaTesto($(this), 60);
				});
			}
		}
	}).resize();

	//Effetti
	if ($('.progetti__container').length > 0) {
		Pace.on('done', () => {
			$('.progetti__container > div:first-of-type')
			.addClass('animated fadeInUp');
		});

		$(window).on('resize', function() {
			$(this).on('scroll', function() {
				if ($(this).width() > 992) {
					if ($(this).scrollTop() >=
					$('.progetti__container > div:first-of-type')
					.offset().top && !primo) {
						precedente = $('.progetti__container > div:first-of-type');
						successivo = $('.progetti__container > div:first-of-type').next();

						successivo.addClass('animated fadeInUp');

						primo = true;
					}
					if (primo && $(this).scrollTop() >=
					successivo.offset().top) {
						precedente = successivo;
						successivo = successivo.next();

						successivo.addClass('animated fadeInUp');
					}
				} else {
					$('.progetti__container > div').addClass('animated fadeInUp');
				}
			}).scroll();
		}).resize();

		if (document.referrer == '/' || document.referrer == '/' == '/home' ||
		document.referrer == '/' == '/home/') {
			$('.progetti__container__progetto').addClass('animated fadeInUp');
		}

		$('.progetti__container__progetto__link').on('click tap', (e) => {
			e.preventDefault();
			$('.progetti__popup').addClass('visibile');
		});
	}
}

/**
 * Funzione gestione references
 */
function references() {
	if ($('.references').length > 0) {
		Pace.on('done', () => {
			$('.references__container__summary').addClass('animated fadeInUp');

			setTimeout(function() {
				$('.references__container__gallery__container__referente:not(:nth-child(2n)):not(:nth-child(3n))')
				.addClass('animated fadeInUp');
			}, 250);
			setTimeout(function() {
				$('.references__container__gallery__container__referente:nth-child(2n)')
				.addClass('animated fadeInUp');
			}, 500);
			setTimeout(function() {
				$('.references__container__gallery__container__referente:nth-child(3n)')
				.addClass('animated fadeInUp');
			}, 750);
			setTimeout(function() {
				$('.references__container__gallery__container__referente')
				.removeClass('animated fadeInUp').addClass('visibile');
			}, 1750);
		});
	}
}

/**
 * Funzione gestione torna su
 */
function tornaSu() {
	$(window).on('scroll', function() {
		if ($(this).scrollTop() > 0) {
			$('.torna-su').addClass('visibile');
		} else {
			$('.torna-su').removeClass('visibile');
		}
	});
	$('.torna-su').on('click tap', () => {
		$('html, body').animate({
			scrollTop: 0,
		}, 'fast');
	});
}

/**
 * Funzione gestione vetrina (Home)
 */
function vetrina() {
	Pace.on('done', () => {
		if ($('.vetrina__container__progetto').length > 0) {
			$('.vetrina__container__progetto:not(:nth-child(2n)):not(:nth-child(3n))')
			.addClass('animated fadeInUp');

			setTimeout(function() {
				$('.vetrina__container__progetto:nth-child(2n)')
				.addClass('animated fadeInUp');
			}, 500);
			setTimeout(function() {
				$('.vetrina__container__progetto:nth-child(3n)')
				.addClass('animated fadeInUp');
			}, 750);
			setTimeout(function() {
				$('.vetrina__container__progetto').removeClass('animated fadeInUp')
				.addClass('visibile');
			}, 1750);
		}
	});

	if ($('.vetrina__container__progetto__link__descrizione__titolo')
	.length > 0) {
		$('.vetrina__container__progetto__link__descrizione__titolo')
		.each(function() {
			formattaTesto($(this), 30);
		});
	}

	$(window).on('resize', function() {
		if ($('.vetrina__container__progetto__link__descrizione__corpo')
		.length > 0) {
			if ($(this).width() >= 1440) {
				$('.vetrina__container__progetto__link__descrizione__corpo')
				.each(function() {
					formattaTesto($(this), 350);
				});
			} else if ($(this).width() >= 992) {
				$('.vetrina__container__progetto__link__descrizione__corpo')
				.each(function() {
					formattaTesto($(this), 250);
				});
			} else if ($(this).width() >= 768) {
				$('.vetrina__container__progetto__link__descrizione__corpo')
				.each(function() {
					formattaTesto($(this), 160);
				});
			}
		}
	}).resize();
}

/**
 * Funzione gestione impostazione cookies
 * @param {string} n Nome cookie
 * @param {string} v Valore cookie
 */
function ck(n, v) {
	let s = new Date();

	s.setDate(s.getDate() + 30);
	document.cookie = n +'='+ escape(v) +'; expires='+ s.toGMTString() +
	'; path=/;';
}

/**
 * Funzione gestione controllo cookies
 * @param {string} n Nome cookie
 * @return {string} Valore cookie
 */
function l(n) {
	if (document.cookie.length > 0) {
		let i = document.cookie.indexOf(n +'=');

		if (i != -1) {
			i = i + n.length + 1;

			let f = document.cookie.indexOf(';', i);

			if (f == -1) {
				f = document.cookie.length;
			}

			return unescape(document.cookie.substring(i, f));
		} else {
			return '';
		}
	}

	return '';
}

/**
 * Funzione gestione eliminazione cookies
 * Setter
 * @param {string} n Nome cookie
 */
function dk(n) {
	document.cookie = n +'=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
}

/**
 * Funzione gestione controllo accettazione cookies
 * Getter
 * @param {string} n Nome cookie
 */
function ak(n) {
	let c = l(n);

	// Controllo Cookie
	// Se non è stata accettata la policy
	if (c === '' && n === 'cookie_law_rivasimone') {
	  $('.container-cookies__policy__form input[type="checkbox"]')
	  .each(function() {
		$(this).attr('checked', 'checked');
	  });
	  $('.container-cookies').fadeIn();
	} else if (c === '') {
	  // Altrimenti se non esiste
	  switch(n) {
		case 'google_rivasimone':
		  $('#google-cookie').removeAttr('checked');

		  break;
		default:
	  }
	} else if (c !== '') {
	  // Altrimenti se esiste
	  switch(n) {
		case 'cookie_law_rivasimone':
		  $('.container-cookies__policy__corpo, .container-cookies__policy__cta--accetta, .container-cookies__chiudi-cookies')
		  .addClass('nascondi');
		  $('.container-cookies, .container-cookies__policy, .container-cookies__policy--avviso')
		  .addClass('chiuso');
		  $('.container-cookies').addClass('mobile');
		  $('.container-cookies__policy__cta--impostazioni').addClass('singolo')
		  .html('cookies');

		  break;
		case 'google_rivasimone':
		  $('#google-cookie').attr('checked', 'checked');

		  break;
		default:
	  }
	}
  }

/**
 * Funzione gestione cookies
 */
function gestisciCookies() {
	document.cookie = 'test_cookie';

	let t = (document.cookie.indexOf('test_cookie') != -1) ? true : false;
	let n = ['cookie_law_rivasimone', 'google_rivasimone'];

	if (t) {
		for (let i in n) {
			ak(n[i]);
		}

		// Impostazioni
		$('.container-cookies__policy__cta--impostazioni')
		.on('click tap', function(e) {
		  e.preventDefault();

		  $('.container-cookies__policy__corpo, .container-cookies__policy__cta--accetta, .container-cookies__chiudi-cookies')
		  .removeClass('nascondi');
		  $('.container-cookies, .container-cookies__policy, .container-cookies__policy--avviso')
		  .removeClass('chiuso');
		  $('.container-cookies').removeClass('mobile');
		  $('.container-cookies__policy__cta--impostazioni')
		  .removeClass('singolo');
		  $('.container-cookies__policy__cta--impostazioni')
		  .html('Impostazioni');
		  $('.container-cookies').addClass('aperto');
		  $('.container-cookies__policy--avviso').collapse('hide');
		  $('.container-cookies__policy--impostazioni').collapse('show');
		});
		// Accettazione
		$('.container-cookies__policy__cta--accetta')
		.on('click tap', function(e) {
		  e.preventDefault();

		  // Cookie Policy
		  if (l('cookie_law_rivasimone') === '') {
			ck('cookie_law_rivasimone', 'accettata');

			// Invio notifica
			$.post($(this).attr('href') +'notificacookies');
		  }

		  // Cookies terze parti
		  $('.container-cookies__policy__form input[type="checkbox"]')
		  .each(function() {
			if (l($(this).val()) === '') {
			  ck($(this).val(), 'accettata');
			  ak($(this).val());
			}
		  });
		});
		// Salvataggio
		$('.container-cookies__policy__cta--salva')
		.on('click tap', (e) => {
		  e.preventDefault();

		  // Aggiornamento Cookies
		  $('.container-cookies__policy__form input[type="checkbox"]')
		  .each((i, elemento) => {
			if ($(elemento).attr('checked')) {
			  ck($(elemento).val(), 'accettata');
			  ak($(elemento).val());
			} else {
				dk($(elemento).val());
			  	ak($(elemento).val());
			}
		  });
		});
		// Opt-Out
		$('.container-cookies__policy__cta--opt-out')
		.on('click tap', (e) => {
		  e.preventDefault();

		  // Disattivazione Cookies
		  $('.container-cookies__policy__form input[type="checkbox"]')
		  .each((i, elemento) => {
			$(elemento).removeAttr('checked');

			dk($(elemento).val());
			ak($(elemento).val());
		  });
		});
		// Chiusura
		$('.container-cookies__chiudi-cookies').on('click tap', () => {
			$('.container-cookies').fadeOut();
		});
		// UX
		$('.container-cookies__policy__form input[type="checkbox"]')
		.on('change', function() {
		  if ($(this).attr('checked')) {
			$(this).removeAttr('checked');
		  } else {
			$(this).attr('checked', 'checked');
		  }
		});
		$('.container-cookies__policy__cta--accetta, .container-cookies__chiudi-impostazioni, .container-cookies__policy__cta--salva')
		.on('click tap', () => {
		  $('.container-cookies__policy--impostazioni').collapse('hide');
		  $('.container-cookies').removeClass('aperto');
		  $('.container-cookies__policy--avviso').collapse('show');
		});
		$('.container-cookies__policy__cta--accetta, .container-cookies__policy__cta--salva')
		.on('click tap', () => {
		  $('.container-cookies__policy__corpo, .container-cookies__policy__cta--accetta, .container-cookies__chiudi-cookies')
		  .addClass('nascondi');
		  $('.container-cookies, .container-cookies__policy, .container-cookies__policy--avviso')
		  .addClass('chiuso');
		  $('.container-cookies').addClass('mobile');
		  $('.container-cookies__policy__cta--impostazioni').addClass('singolo')
		  .html('cookies');
		});
	}
}
